'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./baseEntity'),
    BaseEntity = _require.BaseEntity;

var _require2 = require('../resource'),
    PatentResource = _require2.PatentResource;

module.exports.Patent = function (_BaseEntity) {
  _inherits(Patent, _BaseEntity);

  _createClass(Patent, null, [{
    key: '__name__',
    value: function __name__() {
      return 'patent';
    }
  }]);

  function Patent(data) {
    _classCallCheck(this, Patent);

    var _this = _possibleConstructorReturn(this, (Patent.__proto__ || Object.getPrototypeOf(Patent)).call(this));

    _this._entityName = 'de.ul.fob.domain.Patent';
    _this.datumDerPrioritaetsbegruendendenErstanmeldung = null;
    _this.forschungsgebiet = null;
    _this.kurzbeschreibung = null;
    _this.link = null;
    _this.lizenzen = null;
    _this.titel = null;
    _this.veroeffentlichungsnummer = null;

    _this.anmelderExtern = null;
    _this.anmelderIntern = null;
    _this.ansprechpartner = null;
    _this.haupterfinder = null;
    _this.land = null;
    _this.organisationseinheit = null;
    _get(Patent.prototype.__proto__ || Object.getPrototypeOf(Patent.prototype), 'init', _this).call(_this, data);
    return _this;
  }

  _createClass(Patent, [{
    key: 'toPostData',
    value: function toPostData() {
      return this.genericJSON({
        fields: ['_id', 'datumDerPrioritaetsbegruendendenErstanmeldung', 'forschungsgebiet', 'kurzbeschreibung', 'link', 'lizenzen', 'titel', 'veroeffentlichungsnummer'],
        links: ['anmelderExtern', 'anmelderIntern', 'ansprechpartner', 'haupterfinder', 'land', 'organisationseinheit']
      });
    }
  }, {
    key: 'fetchAnmelderExtern',
    value: function fetchAnmelderExtern() {
      return _get(Patent.prototype.__proto__ || Object.getPrototypeOf(Patent.prototype), 'genericResolve', this).call(this, 'anmelderExtern');
    }
  }, {
    key: 'fetchAnmelderIntern',
    value: function fetchAnmelderIntern() {
      return _get(Patent.prototype.__proto__ || Object.getPrototypeOf(Patent.prototype), 'genericResolve', this).call(this, 'anmelderIntern');
    }
  }, {
    key: 'fetchAnsprechpartner',
    value: function fetchAnsprechpartner() {
      return _get(Patent.prototype.__proto__ || Object.getPrototypeOf(Patent.prototype), 'genericResolve', this).call(this, 'ansprechpartner');
    }
  }, {
    key: 'fetchHaupterfinder',
    value: function fetchHaupterfinder() {
      return _get(Patent.prototype.__proto__ || Object.getPrototypeOf(Patent.prototype), 'genericResolve', this).call(this, 'haupterfinder');
    }
  }, {
    key: 'fetchLand',
    value: function fetchLand() {
      return _get(Patent.prototype.__proto__ || Object.getPrototypeOf(Patent.prototype), 'genericResolve', this).call(this, 'land');
    }
  }, {
    key: 'fetchOrganisationseinheit',
    value: function fetchOrganisationseinheit() {
      return _get(Patent.prototype.__proto__ || Object.getPrototypeOf(Patent.prototype), 'genericResolve', this).call(this, 'organisationseinheit');
    }
  }, {
    key: 'fetchAll',
    value: function fetchAll() {
      return Promise.all([_get(Patent.prototype.__proto__ || Object.getPrototypeOf(Patent.prototype), 'genericResolve', this).call(this, 'anmelderExtern'), _get(Patent.prototype.__proto__ || Object.getPrototypeOf(Patent.prototype), 'genericResolve', this).call(this, 'anmelderIntern'), _get(Patent.prototype.__proto__ || Object.getPrototypeOf(Patent.prototype), 'genericResolve', this).call(this, 'ansprechpartner'), _get(Patent.prototype.__proto__ || Object.getPrototypeOf(Patent.prototype), 'genericResolve', this).call(this, 'haupterfinder'), _get(Patent.prototype.__proto__ || Object.getPrototypeOf(Patent.prototype), 'genericResolve', this).call(this, 'land'), _get(Patent.prototype.__proto__ || Object.getPrototypeOf(Patent.prototype), 'genericResolve', this).call(this, 'organisationseinheit')]);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource() {
      if (typeof PatentResource === 'undefined') {
        return this.fetchAll();
      } else {
        return _get(Patent.prototype.__proto__ || Object.getPrototypeOf(Patent.prototype), 'fetchQuery', this).call(this, PatentResource);
      }
    }
  }]);

  return Patent;
}(BaseEntity);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/patent.js
// module id = 1GyF
// module chunks = 0